import PropTypes from 'prop-types';
import React from 'react';
import { TestimonialContainer } from './styles';
import { getSmallImage } from '../../utils/prismic';

const Testimonial = ({
  authorName,
  authorLabel,
  link,
  avatar,
  center,
  content,
}) => (
  <TestimonialContainer cite={link} center={center}>
    <span className="testimonialHeader">
      {avatar && (
        <img
          className="avatar"
          src={getSmallImage(avatar).url}
          alt={getSmallImage(avatar).alt || authorName + ' ' + authorLabel}
          width={getSmallImage(avatar).width}
          height={getSmallImage(avatar).height}
        />
      )}
    </span>

    <span
      className="testimonialContent"
      dangerouslySetInnerHTML={{ __html: content }}
    />

    <span className="testimonialFooter">
      <span className="author">
        {authorName && <h5>{authorName}</h5>}
        {authorLabel && <h6>{authorLabel}</h6>}
      </span>
      {link && link.url && (
        <a
          className="source"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <h6>View Source</h6>
        </a>
      )}
    </span>
    <span className="background" />
  </TestimonialContainer>
);

Testimonial.propTypes = {
  authorName: PropTypes.string.isRequired,
  authorLabel: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.shape({
    link_type: PropTypes.oneOf(['Any']),
    type: PropTypes.string,
    url: PropTypes.string,
  }),
  avatar: PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    url: PropTypes.string,
    dimensions: PropTypes.object,
    thumbnails: PropTypes.object,
  }),
  center: PropTypes.bool,
};

export default Testimonial;
